import { useEffect, useMemo, useState } from 'react';
import SearchableSelect from './CustomSelect';
import { AoAdminBaseUrl, AoAgenturl, CounterBaseUrl, CounterMobileBaseUrl, intakeBaseUrl, IntakeEntryBaseUrl } from '../network/url';
import { Services } from '../network/Services';
import Toaster from './Toaster';

export default function SwitchRole() {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedRole, setSelectedRole] = useState('');
    const [userRoles, setUserRoles] = useState([]);
    const [toast, setToast] = useState(null);

    const logUserRoles = useMemo(() => {
        if (!userRoles || (typeof sessionStorage == "undefined")) return [];
 
        const newUserRoles = userRoles

        let userRolesFinal = newUserRoles?.filter((item) => item?.roleId != 2 && item?.roleId != 20 && item.roleId != 9 && item.roleId != 7 && item.roleId != 8 && item.roleId != 12 && item.roleId != 19 && item.roleId != 17 && item.roleId != 18)?.map((i) => ({ ...i, value: i.roleId, label: i.roleName }));
    
        const sortOrder = [3, 13, 14, 15, 4, 11, 6, 16];
    
        // Create a shallow copy of the array before sorting
        const sortedRoles = [...userRolesFinal]?.sort((a, b) => {
            const indexA = sortOrder.indexOf(Number(a.roleId));
            const indexB = sortOrder.indexOf(Number(b.roleId));
    
            if (indexA === -1 && indexB === -1) return 0;
            if (indexA === -1) return 1;
            if (indexB === -1) return -1;
            return indexA - indexB;
        });
    
        return sortedRoles;
    }, [userRoles]);

    useEffect(() => {
        fetchRole();
    }, [])

    const fetchRole = async () => {
        let loggedInUserId = sessionStorage.getItem('loggedUserId')
        if(!loggedInUserId) return;
        const _resultOf = await Services.getUserRolesByUserId(loggedInUserId);
        if (_resultOf != 'err' && _resultOf?.data?.length > 0) {
            const resData = _resultOf?.data[0];
            setUserRoles(resData?.roleDetails);
            let userAccess = {userId:resData?.userId,userFullName:resData?.userFullName,isRecordAccess:resData?.isRecordAccess,isRefundAccess:resData?.isRefundAccess}
            console.log(userAccess,"userAccessuserAccess",resData)
            sessionStorage.setItem('userAccess',JSON.stringify(userAccess))
            sessionStorage.setItem('SubtenantId',JSON.stringify(resData?.subtenantId))
        } else {
            setUserRoles([]);
        }
    }

    function getRoleLabel(roleId) {
        const urlMap = {
            '1': intakeBaseUrl + 'login',
            '3': intakeBaseUrl,
            '4': AoAdminBaseUrl,
            '5': AoAgenturl,
            '6': CounterBaseUrl,
            '7': CounterBaseUrl,
            '8': CounterBaseUrl,
            '10': intakeBaseUrl,
            '11': AoAdminBaseUrl,
            '13': intakeBaseUrl,
            '14': intakeBaseUrl,
            '15': intakeBaseUrl,
            '16': CounterMobileBaseUrl,
            '21': IntakeEntryBaseUrl,
        };
        return urlMap[roleId] || '';
    }

    const handleContinue = () => {
        if (!selectedRole) {
            return setToast({ message: 'Please select a role', type: 'error' });
        }
        const stateObj = JSON.parse(sessionStorage.getItem('stateObj'));
        const loggedInUserId = sessionStorage.getItem('loggedUserId');
        const roleId = selectedRole;
        let tokenKey = `appState=${stateObj?.appState}&userId=${loggedInUserId}&roleId=${roleId}&loggenInId=${stateObj?.loggenInId}`;
        let roleUrl = getRoleLabel(selectedRole);
        if (!roleUrl) {
            setToast({ message: "Something went wrong. Please contact your Administrator.", type: 'error' });
            return;
        }
        let redirectUrl = `${roleUrl}?token=${window.btoa(tokenKey)}`
        sessionStorage.clear();
        window.location.replace(redirectUrl);
    }

    const filteredAccounts = logUserRoles.filter(account =>
        account.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <button
                onClick={() => setIsOpen(true)}
                className="px-2 py-1 mx-3 bg-[#720c20] text-white rounded-md hover:bg-[#720c20]"
            >
                Switch Account
            </button>

            {isOpen && <div
                        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-[9998]"
                        style={{ pointerEvents: "auto" }}
                    ><div className="fixed bg-white rounded-lg shadow-2xl w-full max-w-md top-1/4 left-1/2 transform -translate-x-1/2 z-50">
                {/* Header */}
                <div className="bg-[#720c20] text-white px-6 py-4 flex items-center justify-between rounded-t-lg">
                    <button
                        onClick={() => setIsOpen(false)}
                        className="hover:bg-[#720c20] p-1 rounded"
                    >
                        <img src="/whiteBackArrowIcon.svg" className='cursor-pointer' />
                    </button>
                    <h2 className="text-xl font-semibold">Account</h2>
                    <button
                        onClick={() => setIsOpen(false)}
                        className="hover:bg-[#720c20] p-1 rounded"
                    >
                        <img src="/whiteCrossIcon.svg" className='cursor-pointer' />
                    </button>
                </div>

                {/* Content */}
                <div className="p-6">
                    <p className="text-gray-800 font-medium mb-4">
                        Here are the accounts you can switch between
                    </p>

                    {/* Dropdown */}
                    <SearchableSelect
                        value={selectedRole}
                        options={filteredAccounts}
                        onChange={(value) => setSelectedRole(value)}
                        disabled={false}
                        placeholder={`Select Role`}
                    />

                    {/* Continue Button */}
                    <button className="w-full mt-6 bg-[#720c20] text-white py-3 px-6 rounded-lg font-semibold hover:bg-[#720c20] transition-colors" onClick={handleContinue}>
                        Continue
                    </button>
                </div>
            </div></div>}

            {toast && (<Toaster message={toast?.message} type={toast?.type} onClose={() => setToast(null)} />)}
        </>
    );
}